<template>
  <div>
    <div class="row">
      <div class="col-8">
        <h1>Padrões de consumo</h1>
      </div>
      <div class="col-4" style="text-align: right">
        <md-button
          class="md-icon-button md-list-action"
          @click="() => $emit('close')"
        >
          <md-icon>close</md-icon>
          <md-tooltip md-direction="left"> Voltar</md-tooltip>
        </md-button>
      </div>
    </div>

    <div style="text-align: right">
      <md-button
        class="md-primary md-accent"
        @click="
          $emit('delete', {
            changed: changed,
            original: consumos,
          })
        "
      >
        Delete
      </md-button>
      <md-button
        class="md-primary md-raised"
        @click="
          $emit('save', {
            changed: changed,
            original: consumos,
          })
        "
      >
        Salvar
      </md-button>
    </div>

    <md-table v-if="consumos">
      <md-table-row>
        <md-table-head>Id</md-table-head>
        <md-table-head>Idx</md-table-head>
        <md-table-head md-numeric>Valor</md-table-head>
      </md-table-row>
      <md-table-row v-for="value in consumos" :key="value.id">
        <md-table-cell>{{ value.uid }}</md-table-cell>
        <md-table-cell>{{ value.index }}</md-table-cell>
        <md-table-cell md-numeric>
          <div>
            <md-field>
              <label>Consumo</label>
              <md-input
                style="text-align: right"
                :value="value.value"
                number
                @input="(e) => handleInput(e, value)"
              ></md-input>
            </md-field>
          </div>
        </md-table-cell>
      </md-table-row>
    </md-table>
    <md-progress-spinner
      v-else
      md-mode="indeterminate"
      :md-diameter="100"
      :md-stroke="10"
    />
  </div>
</template>

<script>
export default {
  name: 'EpanetShowConsumos',
  props: {
    consumos: {
      type: Array,
      default: null,
    },
    editable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      changed: {},
    }
  },
  methods: {
    handleInput(e, consumo) {
      this.changed[consumo.uid] = {
        ...consumo,
        value: e,
      }
    },
  },
}
</script>
